export const marketingNavigationMock = {
  id: 'YVSq7RAAACEADfaZ',
  uid: 'marketing_nav',
  url: null,
  type: 'top_nav',
  tags: ['Marketing Nav'],
  first_publication_date: '2021-09-30T20:55:43+0000',
  last_publication_date: '2023-10-10T20:55:25+0000',
  slugs: ['top-nav', 'products', 'nav-dropdown'],
  linked_documents: [],
  lang: 'en-us',
  alternate_languages: [],
  data: {
    body: [
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Products',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false,
          columns: 3,
          isdense: false
        },
        items: [
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowcode',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Free QR code generator',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/free-qr-code-generator'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowpage',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Mobile-first landing pages',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/page'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'FlowcodeTV ',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Make any video interactive',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/tv'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowlytics',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Measure performance, gain insights',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowcode-insights'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowtag',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Easily share your contact info in real life',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowtag'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowcode Pixel',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Measure the ROI of your offline campaigns',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/tools/flowcode-pixel'
            },
            fullwidth: false,
            isexternal: false
          }
        ],
        id: 'desktop$4dc071b5-ec18-40e0-9936-20e96243fd6f',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Industries',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/industry'
          },
          isexternal: false,
          columns: 3,
          isdense: true
        },
        items: [
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Explore All',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry'
            },
            fullwidth: true,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'CPG',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/cpg'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Education',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/education'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Entertainment',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/musicians-artists'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Media & Agency',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/media-agency'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Print',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/print'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Real Estate',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: '',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/realestate'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Retail',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/retail'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Sports',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: '',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/sports'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Web3',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/web3'
            },
            fullwidth: false,
            isexternal: false
          }
        ],
        id: 'desktop$6fc8f618-6244-4f00-93cd-6f15b479bce2',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Use Cases',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/use-cases'
          },
          isexternal: false,
          columns: 3,
          isdense: true
        },
        items: [
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Explore All',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases'
            },
            fullwidth: true,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'App Downloads',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-app-downloads'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Collecting CRM',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-crm'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Direct Mail',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-direct-mail'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Donations',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-donations'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Hiring employees',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-hiring'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'NFT sharing',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-nfts'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Open houses',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-open-houses'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Product packaging',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-product-packaging'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Sharing videos',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-videos'
            },
            fullwidth: false,
            isexternal: false
          }
        ],
        id: 'desktop$5186ffe8-2a12-4da8-aa9e-c5661959d498',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Resources',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: true,
          columns: 3,
          isdense: false
        },
        items: [
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Blog',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Resources to grow your business',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/blog'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Flowcode University',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Courses and certifications',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowcode-university'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Onboarding',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Tips for setting up your account',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/onboarding'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Help',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Access the help center',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://help.flowcode.com/en/'
            },
            fullwidth: false,
            isexternal: true
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Feature Releases',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: "See what's new",
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/feature-release-log'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Developer Portal',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Flowcode API integrations',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/developer-portal'
            },
            fullwidth: false,
            isexternal: false
          }
        ],
        id: 'desktop$0c582168-4a91-47a5-9238-235e8023ba40',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Plans',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false,
          columns: 2,
          isdense: false
        },
        items: [
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Enterprise',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For companies',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/enterprise'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Pro Plus',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For professionals',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/proplus'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Growth',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For growing businesses',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/growth'
            },
            fullwidth: false,
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'paragraph',
                text: 'Pro',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For individuals',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/pro'
            },
            fullwidth: false,
            isexternal: false
          }
        ],
        id: 'desktop$45d61909-a693-4daa-9be6-8a733a99bc5f',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'heading2',
              text: 'Pricing',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/plans'
          },
          isexternal: false,
          columns: 4,
          isdense: true
        },
        items: [],
        id: 'desktop$badc0fb4-c688-4abe-8606-5697f3f14143',
        slice_type: 'desktop',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Products',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false
        },
        items: [
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowcode',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Free QR code generator',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/free-qr-code-generator'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowlytics',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Measure performance, gain insights',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowcode-insights'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowpage',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Mobile-first landing pages',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/page'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowtag',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Easily share your contact info in real life',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowtag'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'FlowcodeTV',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Make any video interactive',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/tv'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowcode Pixel ',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Measure the ROI of your offline campaigns',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/tools/flowcode-pixel'
            },
            isexternal: false
          }
        ],
        id: 'mobile$e1dde7dc-4f91-4312-852e-a824df5f311c',
        slice_type: 'mobile',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Industries',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false
        },
        items: [
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Explore All',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'CPG',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/cpg'
            },
            isexternal: true
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Education',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/education'
            },
            isexternal: true
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Entertainment',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/musicians-artists'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Media & Agency',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/media-agency'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Print',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/print'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Real Estate',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: '',
                spans: []
              },
              {
                type: 'paragraph',
                text: '',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/realestate'
            },
            isexternal: true
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Retail',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/retail'
            },
            isexternal: true
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Sports',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/sports'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Web3',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/industry/web3'
            },
            isexternal: true
          }
        ],
        id: 'mobile$19a2aee2-3fa6-4fb8-b1d2-f79fae975775',
        slice_type: 'mobile',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Use Cases',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false
        },
        items: [
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Explore All',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'App Downloads',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-app-downloads'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Collecting CRM',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-crm'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Direct mail',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-direct-mail'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Donations',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-donations'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Hiring employees',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-hiring'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'NFT sharing',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-nfts'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Open Houses',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-open-houses'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Product Packaging',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-product-packaging'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Sharing Videos',
                spans: []
              }
            ],
            link_subtext: [],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-videos'
            },
            isexternal: false
          }
        ],
        id: 'mobile$dc584466-47bc-4af1-8c71-c49c5da04815',
        slice_type: 'mobile',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Resources',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: true
        },
        items: [
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Blog',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Resources to grow your business',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/blog'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Flowcode University',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Courses and certifications',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/flowcode-university'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Help',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Access the help center',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://help.flowcode.com/en/'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Onboarding',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Tips for setting up your account',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/onboarding'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Feature Releases',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: "See what's new",
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/feature-release-log'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Developer Portal ',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'Flowcode API integrations',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/developer-portal'
            },
            isexternal: false
          }
        ],
        id: 'mobile$f8ab25aa-de2c-4a31-9481-2f695bf80845',
        slice_type: 'mobile',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Plans',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Any'
          },
          isexternal: false
        },
        items: [
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Enterprise',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For companies',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/enterprise'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Growth',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For growing businesses',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/growth'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Pro Plus',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For professionals',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/proplus'
            },
            isexternal: false
          },
          {
            link_title: [
              {
                type: 'heading2',
                text: 'Pro',
                spans: []
              }
            ],
            link_subtext: [
              {
                type: 'paragraph',
                text: 'For individuals',
                spans: []
              }
            ],
            dropdown_link: {
              link_type: 'Web',
              url: 'https://www.flowcode.com/pro'
            },
            isexternal: false
          }
        ],
        id: 'mobile$17077323-e105-4f0c-8f2b-f12d374d90ea',
        slice_type: 'mobile',
        slice_label: null
      },
      {
        primary: {
          header: [
            {
              type: 'paragraph',
              text: 'Pricing',
              spans: []
            }
          ],
          header_link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/plans'
          },
          isexternal: false
        },
        items: [],
        id: 'mobile$fbfc5fb8-8031-47e7-83f0-d4881f8c78ee',
        slice_type: 'mobile',
        slice_label: null
      }
    ]
  }
}
